import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Typography, Paper, CircularProgress, Alert } from "@mui/material";
import { toast } from "react-toastify";
import { usePlaylists } from "../../hooks/useRedux";
import PlaylistForm from "./PlaylistForm";
import { Playlist } from "../../store/slices/types";

const EditPlaylist: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { playlists, updatePlaylist, loading } = usePlaylists();

  const playlist = playlists.find(
    (p) => (p._id || p.id) === id
  ) as Playlist | undefined;

  const handleSave = async (playlistData: Partial<Playlist>) => {
    if (!id) {
      toast.error("Invalid playlist ID");
      return;
    }

    try {
      await updatePlaylist(id, playlistData);
      toast.success("playlist is updated");
      navigate("/playlists");
    } catch (error) {
      console.error("Failed to update playlist:", error);
      toast.error(
        `❌ Failed to update playlist: ${
          error instanceof Error ? error.message : "Unknown error"
        }`
      );
    }
  };

  const handleCancel = () => {
    navigate("/playlists");
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 400,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!playlist) {
    return (
      <Box>
        <Alert severity='error' sx={{ mb: 2 }}>
          Playlist not found
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          mb: 4,
        }}
      >
        <Typography variant='h4' fontWeight='700' gutterBottom>
          Edit Playlist
        </Typography>
        <Typography variant='body1' sx={{ opacity: 0.9 }}>
          Update your playlist
        </Typography>
      </Paper>

      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <PlaylistForm
          playlist={playlist}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </Paper>
    </Box>
  );
};

export default EditPlaylist;

